import {Component, inject, OnInit} from '@angular/core';
import {RegistryService} from '../../services/RegistryService';
import {AuthService} from '../../services/AuthService';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  public registry = inject(RegistryService);
  public auth = inject(AuthService);

  ngOnInit(): void {
  }
}
